import React, { useEffect, useState, useContext, useMemo } from "react";
import { FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavBtnLink,
  NavItem,
  NavLogo,
  NavMenu,
} from "../Navbar/NavbarElements";
import axios from "axios";

import LogoPng from "../../image/icon.png";

const normalizeRole = (role) => {
  if (!role) return "client";
  if (role === "driver") return "chauffeur";
  return role;
};

const Navbar = ({ toggle }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [scrollNav, setScrollNav] = useState(false);
  const [userType, setUserType] = useState(
    normalizeRole(localStorage.getItem("userType"))
  );

  const { isAuthenticated, logout, role } = useContext(AuthContext);
  const navigate = useNavigate();

  const API = process.env.REACT_APP_API_URL || "http://localhost:5002";

  const normalizedRole = useMemo(() => {
    return normalizeRole(role || userType || localStorage.getItem("userType"));
  }, [role, userType]);

  const isDriver = normalizedRole === "chauffeur";

  useEffect(() => {
    const changeNav = () => setScrollNav(window.scrollY >= 80);
    window.addEventListener("scroll", changeNav);
    return () => window.removeEventListener("scroll", changeNav);
  }, []);

  useEffect(() => {
    const syncUserType = () => {
      setUserType(normalizeRole(localStorage.getItem("userType")));
    };

    window.addEventListener("storage", syncUserType);
    window.addEventListener("userTypeChanged", syncUserType);

    syncUserType();

    return () => {
      window.removeEventListener("storage", syncUserType);
      window.removeEventListener("userTypeChanged", syncUserType);
    };
  }, []);

  const toggleHome = () => scroll.scrollToTop();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const storedUserType = normalizeRole(localStorage.getItem("userType"));
        setUserType(storedUserType);

        if (!token || !isAuthenticated) {
          setUserInfo(null);
          return;
        }

        const endpoint =
          storedUserType === "chauffeur"
            ? `${API}/api/chauffeurs/profile-chauffeur`
            : `${API}/api/clients/profile-client`;

        const res = await axios.get(endpoint, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUserInfo(res.data);
      } catch (err) {
        console.error("Erreur profil navbar:", err);
        setUserInfo(null);
      }
    };

    fetchProfile();
  }, [API, isAuthenticated, normalizedRole]);

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    setUserInfo(null);
    setUserType("client");
    localStorage.removeItem("userType");
    navigate("/");
  };

  return (
    <IconContext.Provider value={{ color: "#000" }}>
      <Nav scrollNav={scrollNav}>
        <NavbarContainer>
          <NavLogo
            to="/"
            onClick={toggleHome}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src={LogoPng}
              alt="On The Road"
              style={{
                height: 58,
                width: "auto",
                display: "block",
                objectFit: "contain",
              }}
            />
          </NavLogo>

          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>

          <NavMenu>
            {isAuthenticated ? (
              <>
                {userInfo?.firstName && (
                  <NavItem>
                    <span style={{ color: "white", fontWeight: "bold" }}>
                      Bienvenue {userInfo.firstName}
                    </span>
                  </NavItem>
                )}

                <NavItem>
                  <NavBtnLink to="/news" $secondary>
                    News
                  </NavBtnLink>
                </NavItem>

                <NavItem>
                  <NavBtnLink to="/avis" $secondary>
                    Avis
                  </NavBtnLink>
                </NavItem>

                {isDriver && (
                  <NavItem>
                    <NavBtnLink to="/mes-documents" $secondary>
                      Mes Documents
                    </NavBtnLink>
                  </NavItem>
                )}

                <NavItem>
                  <NavBtnLink to="/profile" $secondary>
                    Profil
                  </NavBtnLink>
                </NavItem>

                <NavItem>
                  <NavBtnLink
                    to="/"
                    onClick={handleLogout}
                    $danger
                    style={{ cursor: "pointer" }}
                  >
                    Déconnexion
                  </NavBtnLink>
                </NavItem>
              </>
            ) : (
              <>
                <NavItem>
                  <NavBtnLink to="/contact" $secondary>
                    Contact
                  </NavBtnLink>
                </NavItem>

                <NavItem>
                  <NavBtnLink to="/" style={{ cursor: "pointer" }}>
                    Connexion
                  </NavBtnLink>
                </NavItem>
              </>
            )}
          </NavMenu>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
};

export default Navbar;